// https://v4.mui.com/components/about-the-lab/#typescript
import type { } from '@material-ui/lab/themeAugmentation';

import { createTheme, useTheme } from '@material-ui/core/styles';

import { MuiAccordion } from '../Accordion/styles';
import { MuiAccordionDetails } from '../AccordionDetails/styles';
import { MuiAccordionSummary } from '../AccordionSummary/styles';
import { MuiAlert } from '../Alert/styles';
import { MuiAlertTitle } from '../AlertTitle/styles';
import { MuiAutocomplete } from '../Autocomplete/styles';
import { MuiBackdrop } from '../Backdrop/styles';
import { MuiButton } from '../Button/styles';
import { MuiCard } from '../Card/styles';
import { MuiCardActionArea } from '../CardActionArea/styles';
import { MuiCheckbox } from '../Checkbox/styles';
import { MuiChip } from '../Chip/styles';
import { MuiDialogActions } from '../DialogActions/styles';
import { MuiDialogContent } from '../DialogContent/styles';
import { MuiDialogTitle } from '../DialogTitle/styles';
import { MuiDialog} from '../Dialog/styles';
import { MuiDivider } from '../Divider/styles';
import { MuiFormControlLabel } from '../FormControlLabel/style';
import { MuiFormHelperText } from '../FormHelperText/styles';
import { MuiFormLabel } from '../FormLabel/styles';
import { MuiIconButton } from '../IconButton/styles';
import { MuiLinearProgress } from '../LinearProgress/styles';
import { MuiLink } from '../Link/styles';
import { MuiList } from '../List/styles';
import { MuiListSubheader } from '../ListSubheader/styles';
import { MuiMenuItem } from '../MenuItem/styles';
import { MuiOutlinedInput } from '../OutlinedInput/styles';
import { MuiRadio } from '../Radio/styles';
import { MuiSelect } from '../Select/styles';
import { MuiSlider } from '../Slider/styles';
import { MuiSnackbarContent } from '../SnackbarContent/styles';
import { MuiStepConnector } from '../StepConnector/styles';
import { MuiStepIcon } from '../StepIcon/styles';
import { MuiStepLabel } from '../StepLabel/styles';
import { MuiStepper } from '../Stepper/styles';
import { MuiSvgIcon } from '../Icon/styles';
import { MuiSwitch } from '../Switch/styles';
import { MuiTab } from '../Tab/styles';
import { MuiTableCell } from '../TableCell/styles';
import { MuiTablePagination } from '../TablePagination/styles';
import { MuiTableRow } from '../TableRow/styles';
import { MuiTabs } from '../Tabs/styles';
import { MuiToggleButton } from '../ToggleButton/styles';
import { MuiToggleButtonGroup } from '../ToggleButtonGroup/styles';
import { MuiTooltip } from '../Tooltip/styles';
import { MuiTypography } from '../Typography/styles';

import { core } from './core';

export const useMUITheme = () => useTheme();

export const theme = createTheme(
  {
    overrides: {
      MuiAccordion,
      MuiAccordionDetails,
      MuiAccordionSummary,
      MuiAlert,
      MuiAlertTitle,
      MuiAutocomplete,
      MuiBackdrop,
      MuiButton,
      MuiCard,
      MuiCardActionArea,
      MuiCheckbox,
      MuiChip,
      MuiDialogActions,
      MuiDialogContent,
      MuiDialogTitle,
      MuiDialog,
      MuiDivider,
      MuiFormControlLabel,
      MuiFormHelperText,
      MuiFormLabel,
      MuiIconButton,
      MuiLinearProgress,
      MuiLink,
      MuiList,
      MuiListSubheader,
      MuiMenuItem,
      MuiOutlinedInput,
      MuiRadio,
      MuiSelect,
      MuiSlider,
      MuiSnackbarContent,
      MuiStepConnector,
      MuiStepIcon,
      MuiStepLabel,
      MuiStepper,
      MuiSvgIcon,
      MuiSwitch,
      MuiTab,
      MuiTableCell,
      MuiTablePagination,
      MuiTableRow,
      MuiTabs,
      MuiToggleButton,
      MuiToggleButtonGroup,
      MuiTooltip,
      MuiTypography,
    },
  },
  core
);
